// Slow-connection signal: counts requests still waiting after SLOW_AFTER_MS. The slow-connection
// banner shows while any is; it hides as soon as the last slow one settles (either way).
import { useSyncExternalStore } from "react";

export const SLOW_AFTER_MS = 2_000;

let slowCount = 0;
const listeners = new Set<() => void>();

function change(delta: number) {
  slowCount += delta;
  listeners.forEach((listener) => listener());
}

/** Wraps one request; the result or failure passes through unchanged. */
export function trackRequest<T>(work: Promise<T>): Promise<T> {
  let late = false;
  const timer = setTimeout(() => {
    late = true;
    change(1);
  }, SLOW_AFTER_MS);
  const settle = () => {
    clearTimeout(timer);
    if (late) change(-1);
  };
  work.then(settle, settle);
  return work;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

const read = () => slowCount > 0;

export function useSlowNetwork(): boolean {
  return useSyncExternalStore(subscribe, read, read);
}
